/**
 * @module actions/orderfiles
 */
import axios from 'axios'
import { API_URL, FILE_STORAGE_API } from '../constants'

/**
 * @description Get order files for sharing purpose
 * @return {Promise} Axios promise
 * @param {orderId} orderId
 */
export function getOrderFileSharing (orderId) {
  let url = API_URL + '/FileService/GetOrderFiles/' + orderId
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Save sharing marking on order files
 * @return {Promise} Axios promise
 */
export function saveOrderFileSharing (data) {
  let url = API_URL + '/FileService/OrderFileSharing/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Get size of order files
 * @return {Promise} Axios promise
 */
export function getOrderFileSizes (fileIds) {
  let url = FILE_STORAGE_API + '/FileService/OrderFileSizes'
  return dispatch => {
    return axios.post(url, fileIds)
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/orderfiles.js